<script>
    import { ST_score, ST_hiScore } from "../stores.js";

    let hiScore = 0;
    let score = 0;

    ST_hiScore.subscribe((value) => {
        hiScore = value;
    });

    ST_score.subscribe((value) => {
        score = value;
    });

</script>

<style>
    .nav-font {
        font-size: x-large;
        font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
            "Lucida Sans", Arial, sans-serif;
    }
</style>

<nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
        <p class="navbar-item nav-font">Hi-Score: {hiScore}</p>
        <p class="navbar-item nav-font">Score: {score}</p>
    </div>
</nav>
